export default "__VITE_ASSET__b1bed976__"